// extracted by mini-css-extract-plugin
export var horizontal = "Divider-module--horizontal--b06c9";
export var image = "Divider-module--image--f560c";
export var responsive = "Divider-module--responsive--eda9c";
export var vertical = "Divider-module--vertical--d7450";